<template>
  <div class="tree-title" :style="{'margin-bottom':marginBottom,'line-height': lineHeight}" :title="treeTitle">
    {{treeTitle}}
  </div>
</template>

<script>
export default {
  name: 'EXHoverTitle',
  props: {
    treeTitle: String,
    marginBottom: String,
    lineHeight: String
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';
.tree-title {
  // font-size: .16rem;
  // font-family: Microsoft YaHei;
  font-weight: 700;
  color: #333;
  // width: 2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  // margin-bottom: 0.1rem;
  line-height: .4rem;
  &::before {
    content: "|";
    display: inline-block;
    width: .03rem;
    height: .21rem;
    color: transparent;
    @include hover_title_color($title-colorD);
    line-height: .21rem;
    margin-right: .03rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/EXHoverTitle/index.vue